// The chandelier trailing stop on live signals and backtest trades (DWLF-341).
// The backend writes `trailingStop` (the rule) on a trailing signal and
// `currentStopLevel` (the stop in force) as it moves; a stop-out keeps status
// 'Stopped Out' with `exitReason: 'trailing_stop'` and its real `currentRR`.
// Display only: every number here comes from the API.

const finiteOrNull = (value) => {
  if (value === null || value === undefined || value === '') {return null;}
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/** A signal whose stop trails: keyed on the rule, not on currentStopLevel being present. */
export const isTrailingSignal = (signal) => Boolean(signal?.trailingStop);

/** The trailed stop in force, or null for a fixed stop (or before its first update). */
export const trailingStopLevel = (signal) => (isTrailingSignal(signal) ? finiteOrNull(signal.currentStopLevel) : null);

/** The stop to show: the trailed level when there is one, else the stop as stored. */
export const stopInForce = (signal) => {
  const trailed = trailingStopLevel(signal);
  if (trailed !== null) {return trailed;}
  return signal?.stopLossLevel ?? signal?.stopLoss ?? signal?.initialStop ?? signal?.stop;
};

/**
 * A trailing stop-out's outcome by its API R, or null for any other signal.
 * Its chipColor is the MUI colour: a gain is success, a loss error, and an exit at
 * exactly 0R or without an R is neutral (an absent R is not a loss).
 */
export const trailingExit = (signal) => {
  if (signal?.exitReason !== 'trailing_stop') {return null;}
  const rr = finiteOrNull(signal.currentRR);
  if (rr === null || rr === 0) {return { outcome: 'flat', chipColor: 'default' };}
  return rr > 0 ? { outcome: 'won', chipColor: 'success' } : { outcome: 'lost', chipColor: 'error' };
};
